import { defineMessages, useIntl } from "react-intl";

import { Chip, type ChipColor } from "@/components/Chip/Chip";
import type { FindUserReservationsExternalFlightReservation } from "@/types/codegen";

type Props = {
  status: FindUserReservationsExternalFlightReservation["status"];
};

const statusToColorMapping: {
  [key in FindUserReservationsExternalFlightReservation["status"]]: ChipColor;
} = {
  IN_PROGRESS: "warning",
  TICKET_ISSUED: "success",
  OK: "success",
  BOOKED: "success",
  REFUNDED: "error",
};

const statusLabels = defineMessages<string>({
  IN_PROGRESS: { id: "reservations.orderStatuses.inProgress" },
  TICKET_ISSUED: { id: "reservations.orderStatuses.ticketIssued" },
  OK: { id: "reservations.orderStatuses.booked" },
  BOOKED: { id: "reservations.orderStatuses.booked" },
  REFUNDED: { id: "reservations.orderStatuses.refunded" },
});

export const OrderLabel = ({ status }: Props) => {
  const intl = useIntl();

  return (
    <Chip
      color={statusToColorMapping[status]}
      label={intl.formatMessage(statusLabels[status])}
    />
  );
};
